export const LEVELS = [
  { level: 1, points: 0, boost: 0 },
  { level: 2, points: 1000, boost: 1 },
  { level: 3, points: 3000, boost: 2 },
  { level: 4, points: 7000, boost: 3 },
  { level: 5, points: 12000, boost: 4 },
  { level: 6, points: 18000, boost: 5 },
  { level: 7, points: 27000, boost: 6 },
  { level: 8, points: 38000, boost: 7 },
  { level: 9, points: 51000, boost: 8 },
  { level: 10, points: 66000, boost: 10 },
  { level: 11, points: 83000, boost: 11.5 },
  { level: 12, points: 104000, boost: 13 },
  { level: 13, points: 126000, boost: 14.5 },
  { level: 14, points: 152000, boost: 16 },
  { level: 15, points: 180000, boost: 17.5 },
  { level: 16, points: 212000, boost: 19 },
  { level: 17, points: 246000, boost: 20.5 },
  { level: 18, points: 284000, boost: 22 },
  { level: 19, points: 325000, boost: 23.5 },
  { level: 20, points: 369000, boost: 25 },
  { level: 21, points: 416000, boost: 27 },
  { level: 22, points: 467000, boost: 29 },
  { level: 23, points: 521000, boost: 31 },
  { level: 24, points: 580000, boost: 33 },
  { level: 25, points: 641000, boost: 35 },
  { level: 26, points: 707000, boost: 37 },
  { level: 27, points: 776000, boost: 39 },
  { level: 28, points: 850000, boost: 41 },
  { level: 29, points: 927000, boost: 43 },
  { level: 30, points: 1008000, boost: 45 },
  { level: 31, points: 1094000, boost: 47.5 },
  { level: 32, points: 1184000, boost: 50 },
  { level: 33, points: 1277000, boost: 52.5 },
  { level: 34, points: 1376000, boost: 55 },
  { level: 35, points: 1478000, boost: 57.5 },
  { level: 36, points: 1585000, boost: 60 },
  { level: 37, points: 1697000, boost: 62.5 },
  { level: 38, points: 1813000, boost: 65 },
  { level: 39, points: 1934000, boost: 67.5 },
  { level: 40, points: 2059000, boost: 70 },
  { level: 41, points: 2189000, boost: 73 },
  { level: 42, points: 2324000, boost: 76 },
  { level: 43, points: 2464000, boost: 79 },
  { level: 44, points: 2608000, boost: 82 },
  { level: 45, points: 2758000, boost: 85 },
  { level: 46, points: 2913000, boost: 88 },
  { level: 47, points: 3072000, boost: 91 },
  { level: 48, points: 3237000, boost: 94 },
  { level: 49, points: 3407000, boost: 97 },
  { level: 50, points: 3582000, boost: 100 },
  { level: 51, points: 3762000, boost: 103.5 },
  { level: 52, points: 3948000, boost: 107 },
  { level: 53, points: 4139000, boost: 110.5 },
  { level: 54, points: 4336000, boost: 114 },
  { level: 55, points: 4538000, boost: 117.5 },
  { level: 56, points: 4745000, boost: 121 },
  { level: 57, points: 4958000, boost: 124.5 },
  { level: 58, points: 5177000, boost: 128 },
  { level: 59, points: 5401000, boost: 131.5 },
  { level: 60, points: 5631000, boost: 135 },
  { level: 61, points: 5867000, boost: 139 },
  { level: 62, points: 6108000, boost: 143 },
  { level: 63, points: 6356000, boost: 147 },
  { level: 64, points: 6609000, boost: 151 },
  { level: 65, points: 6868000, boost: 155 },
  { level: 66, points: 7133000, boost: 159 },
  { level: 67, points: 7404000, boost: 163 },
  { level: 68, points: 7682000, boost: 167 },
  { level: 69, points: 7965000, boost: 171 },
  { level: 70, points: 8255000, boost: 175 },
  { level: 71, points: 8550000, boost: 179.5 },
  { level: 72, points: 8852000, boost: 184 },
  { level: 73, points: 9160000, boost: 188.5 },
  { level: 74, points: 9475000, boost: 193 },
  { level: 75, points: 9796000, boost: 197.5 },
  { level: 76, points: 10123000, boost: 202 },
  { level: 77, points: 10457000, boost: 206.5 },
  { level: 78, points: 10797000, boost: 211 },
  { level: 79, points: 11144000, boost: 215.5 },
  { level: 80, points: 11497000, boost: 220 },
  { level: 81, points: 11857000, boost: 225 },
  { level: 82, points: 12223000, boost: 230 },
  { level: 83, points: 12597000, boost: 235 },
  { level: 84, points: 12976000, boost: 240 },
  { level: 85, points: 13363000, boost: 245 },
  { level: 86, points: 13757000, boost: 250 },
  { level: 87, points: 14157000, boost: 255 },
  { level: 88, points: 14564000, boost: 260 },
  { level: 89, points: 14978000, boost: 265 },
  { level: 90, points: 15399000, boost: 270 },
  { level: 91, points: 15827000, boost: 275.5 },
  { level: 92, points: 16262000, boost: 281 },
  { level: 93, points: 16704000, boost: 286.5 },
  { level: 94, points: 17154000, boost: 292 },
  { level: 95, points: 17610000, boost: 297.5 },
  { level: 96, points: 18074000, boost: 303 },
  { level: 97, points: 18544000, boost: 308.5 },
  { level: 98, points: 19022000, boost: 314 },
  { level: 99, points: 19500000, boost: 319.5 },
  { level: 100, points: 21000000, boost: 325 },
];

export const ZEALY_BONUS = 30;

export const BONUS_TYPES = {
  all: (item) => !(item.expired && !item.completed),
  completed: (item) => item.completed,
  incomplete: (item) => !item.expired && !item.completed,
};

export const getLevelByXP = (xp) => {
  let currentLevel = LEVELS[0];
  for (let i = 0; i < LEVELS.length; i++) {
    if (xp >= LEVELS[i].points) {
      currentLevel = LEVELS[i];
    } else {
      break;
    }
  }
  return currentLevel;
};

export const getNextLevelXP = (currentLevel) => {
  if (currentLevel < 0 || currentLevel >= LEVELS.length) {
    return 0;
  }

  return LEVELS[currentLevel].points;
};

export const getBoostbyLevel = (level) => {
  const index = level - 1;
  if (index < 0 || index >= LEVELS.length) {
    return 0;
  }
  return LEVELS[index].boost;
};

export const getLevel = (level) => {
  const index = level - 1;
  if (index < 0 || index >= LEVELS.length) {
    return 0;
  }
  return LEVELS[index];
};
